<i18n
  src="@/locales/views/packing_house/production/uniq_final_packing_list/show_container.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link :text="$t('labels.go_back_link')" :name='routeName("show_process")' :params="{
    packing_house_process_id: this.packing_house_process_id,
  }"></go-back-link>

  <bread-crumbs :labels="[
    module_name,
    packing_house_process?.name,
    container_label,
  ]" />

  <template v-if="load_general_data">
    <div class="mt-8">
      <tabs-container v-model="option_tabs" :with_routing="true" />

      <div class="mt-6">
        <router-view v-model:container="container" v-model:package_groups="package_groups"
          :container_code="container?.container_code" @update:packages-groups="updatePackagesGroups($event)">
        </router-view>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/uniq_final_packing_list.js";

export default {
  components: {},
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: { required: true },
    container_id: { required: true },
  },
  data() {
    return {
      load_general_data: false,
      packing_house_process: {},
      container: null,
      option_tabs: [],
    };
  },
  computed: {
    vue_context: function () {
      return this;
    },
    container_code() {
      return this.container ? this.container.container_code : "";
    },
    container_label: function () {
      let label = this.container_code;
      const brand_name = this.container?.exporter_process_brand?.agro_exporter_brand?.name;
      if (brand_name) label = `${label} (${brand_name})`;
      return label;
    },
    package_groups() {
      return this.container ? this.container.package_groups : [];
    },
    all_packages() {
      return this.container
        ? this.container.package_groups.map((pg) => pg.packages).flat()
        : [];
    },
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response =
        await Requester.fetchPackingHouseProcess(
          this.packing_house_process_id
        );
      this.packing_house_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.container({
        packing_house_process_id: this.packing_house_process_id,
        container_id: this.container_id,
      });
      this.container = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.container_tab_title"),
          icon: "fa-solid fa-truck-container",
          route: { name: this.routeName("show_container_resume") },
        },
        {
          name: this.$t("labels.pallets_tab_title"),
          icon: "fa-solid fa-pallet-boxes",
          route: { name: this.routeName("show_container_pallets") },
        },
        {
          name: this.$t("labels.sizes_by_pallet_tab_title"),
          icon: "fa-solid fa-pallet-box",
          route: { name: this.routeName("show_container_sizes_by_pallet") },
        },
        // {
        //   name: this.$t("labels.packages_tab_title"),
        //   icon: "fa-solid fa-user",
        //   route: { name: this.routeName("show_container_packages") },
        // },
        {
          name: this.$t("labels.cross_tab_title"),
          icon: "fa-solid fa-box",
          route: { name: this.routeName("show_container_cross") },
        },
      ];
    },
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fillOptions();
      this.load_general_data = true;
    },
    updatePackagesGroups: function (package_groups) {
      if (this.container) {
        this.container.package_groups = package_groups;
      }
    },
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.loadData();
      })
    );
  },
};
</script>
